
import { message } from "antd";
import FetchData from '@ezviz/FetchData';
import util from "../../utils/utils";
import { languageList } from "../../common/utils";
export const GET_EVENT_LIST = "GET_EVENT_LIST";
export const UPDATE_EVENTCONFIG_DETAIL = "UPDATE_EVENTCONFIG_DETAIL";
export const UPDATE_EVENT_LOADING_STATUS = "UPDATE_EVENT_LOADING_STATUS";


message.config({
  top: 300,
  maxCount: 3
});

export function updateLoadingStatus(loading) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_EVENT_LOADING_STATUS,
      loading
    });
  };
}

//获取事件配置列表
export function getEVentList(params,callback) {
    return (dispatch, getState) => {
      const { productDetail } = getState().product;
      const { firmwareUpgradeCode, productId } = productDetail;
      const defaultParam = {
        offset: 0,
        limit: 100000,
        version: firmwareUpgradeCode,
        pid: productId,
      };
      dispatch(updateLoadingStatus(true));
      const fetchData = new FetchData(`/iot/config/api/iot/support/product/feature/${params.pid}/page`, {
        method: "POST",
        body: defaultParam,
        metaHandler: {
          403: () => { window.location.href = '/authrization/login'; return; }
        },
      });
      fetchData
        .then(data => {
          dispatch(updateLoadingStatus(false));
          let newData = {}
          if(data.data && data.data.customizeFeatures && data.data.templateFeatures){
            const customizeFeatures = data.data.customizeFeatures.map(value=>{
              let newValue = {...value};
               //功能点中deName拆分出deNameCh和deNameEn
              newValue.deNameCh = util.parseJSON(value.deName).zh;
              newValue.deNameEn = util.parseJSON(value.deName).en;
              //isStandard为1代表自定义功能
              newValue.isStandard = 1;
              return newValue
            })
            const templateFeatures = data.data.templateFeatures.map(value=>{
              let newValue = {...value};
               //功能点中deName拆分出deNameCh和deNameEn
              newValue.deNameCh = util.parseJSON(value.deName).zh;
              newValue.deNameEn = util.parseJSON(value.deName).en;
              return newValue
            })
            // newData = {customizeFeatures,templateFeatures}
            //标准功能无事件配置
            newData = {customizeFeatures}
          }
          // const allFeaturesList =newData.customizeFeatures.concat(newData.templateFeatures);
          const allFeaturesList =newData.customizeFeatures;
          const eventList = allFeaturesList.filter(x=>x.featureType === "3")
          if (data.code == '200') {
            callback&&callback(eventList)
            dispatch({
              type: GET_EVENT_LIST,
              eventList,
            });
          }
        })
        .catch(e => {
        });
  };
}

//查询消息模板配置数据
export function getEventConfigDetail(params) {
  return (dispatch, getState) => {
    const url = '/iot/config/api/iot/support/event/msg';
    const fetchData = new FetchData(url, {
      headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: "GET",
      body: {
        productId: params.productId,
        dId: params.dId,
        eKey: params.eKey,
        language:"zh,en"
      },
      metaHandler: {
        403: () => {window.location.href = '/authrization/login'; return;}
      },
    });
    const { eventConfigDetail } = getState().eventConfigEdit;
    // dispatch({
    //   type: UPDATE_EVENTCONFIG_DETAIL,
    //   eventConfigDetail: {...eventConfigDetail,productId: params.productId,dId: params.dId,eKey: params.eKe,}
    // });
    fetchData
      .then(res => {
        if (res.code == '200') {
          const { data } = res
          if(data){
            const newData = {...data,productId: params.productId,dId: params.dId,eKey: params.eKey}
            newData.ePushCh = util.parseJSON(data.ePush).zh || '请输入消息内容';
            newData.ePushEn = util.parseJSON(data.ePush).en || 'Please enter the message content';
            newData.eDetailCh = util.parseJSON(data.eDetail).zh || '请输入消息内容';
            newData.eDetailEn = util.parseJSON(data.eDetail).en || 'Please enter the message content';
            newData.eListCh = util.parseJSON(data.eList).zh || '请输入消息内容';
            newData.eListEn = util.parseJSON(data.eList).en || 'Please enter the message content';
            dispatch({
              type: UPDATE_EVENTCONFIG_DETAIL,
              eventConfigDetail: newData,
              hasData: "yes",
            });
            
          }else if(data == null){
            const data = {
              //产品ID
              productId: params.productId,
              //领域ID
              dId: params.dId,
              //事件key
              eKey: params.eKey,
              //消息分类
              eCategory: "",
              //事件名称
              eName: "",
              //是否提醒用户 不提醒：NO 提醒：YES
              eNotice: "YES",
              //消息类型 信息类：text 视频类：video
              eMsgType: "text",
              //客户端入口 告警：alarm 通知：notice
              eClientEntrance: "alarm",
              //消息Code
              eCode: "",
              //事件推送文案
              ePush: "",
              //事件推送文案(中文)
              ePushCh: "",
              //事件推送文案(英文)
              ePushEn: "",
              //消息列表文案
              eList: "",
              //消息列表文案(中文)
              eListCh: "",
              //消息列表文案(英文)
              eListEn: "",
              //消息详情文案
              eDetail: "",
              //消息详情文案(中文)
              eDetailCh: "",
              //消息详情文案(英文)
              eDetailEn: "", 
              //RN/H5链接(推送)
              eRhPush: "",
              //RN/H5链接(消息列表)
              eRhList: "",
              //默认图片
              ePicurl: "",
              //上报频率控制
              eReportInterval: 1,
              //存储生命周期
              eStorageCycle: 7,
              //推送间隔
              ePushInterval: 1
            }
            dispatch({
              type: UPDATE_EVENTCONFIG_DETAIL,
              eventConfigDetail: data,
              hasData: "no",
            });
          }
        }
      })
      .catch(e => {
        dispatch(updateLoadingStatus(false));
      });
  };
}
